import React from 'react'
import Title from '../components/Title'
import { useState } from 'react'


const InquiryForm = () => {
    const [formData, setFormData] = useState({
        name: "",
        company:"",
        mobile:"",
        email: "",
        subject: "",
        message: "",
    });

    const [responseMessage, setResponseMessage] = useState("");

    // Handle input changes
    const handleChange = (e) => {
    const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
          const response = await fetch("https://betalinkquate.ecomuntant.com/api/testformdata", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          });
    
          if (response.ok) {
            setResponseMessage("Your inquiry has been submitted successfully!");
            setFormData({
                name: "",
                company:"",
                mobile:"",
                email: "",
                subject: "",
                message: "",
            });
          } else {
            setResponseMessage("Error submitting the inquiry. Please try again.");
          }
        } catch (error) {
          console.error("Error:", error);
          setResponseMessage("Something went wrong. Please try again.");
        }

    };

  return (
    <div className="App mt-5 mb-5">
        <div className='main_wrapper back_clr'>
            <div className='form_design pt-3 pb-3'>
            <div className='container'>
                <div className='section_main_title d-flex align-items-center justify-content-between'>
                    <Title text="SUBMIT YOUR QUERY." className="custom-heading" />
                    <ul className='d-flex align-items-center'>
                    <li className='orange'>Reach Out for Expert Guidance </li>
                    </ul>
                </div>
            </div>
            </div>
            <div className='container'>
                <div className='row align-items-center'>
                    <div className='col-md-7'>
                        <div className='inquery_form'>
                            {responseMessage && <p>{responseMessage}</p>}
                            <form onSubmit={handleSubmit} className='row'>
                                <div className='col-md-6'>
                                    <div className='input_column'>
                                        <label>Name:</label>
                                        <input type="text" name="name" value={formData.name} onChange={handleChange} required/>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='input_column'>
                                        <label>Company:</label>
                                        <input type="text" name="company" value={formData.company} onChange={handleChange} required/>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='input_column'>
                                        <label>Mobile:</label>
                                        <input type="text" name="mobile" value={formData.mobile} onChange={handleChange} required/>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='input_column'>
                                        <label>Email:</label>
                                        <input type="email" name="email" value={formData.email} onChange={handleChange} required/>
                                    </div>
                                </div>
                                <div className='col-md-12'>
                                    <div className='input_column'>
                                    <label>Subject:</label>
                                    <input type="text" name="subject" value={formData.subject}onChange={handleChange} />
                                    </div>
                                </div>
                                <div className='col-md-12'>
                                    <div className='input_column'>
                                        <label>Your Message:</label>
                                        <textarea name="message" value={formData.message} onChange={handleChange} required></textarea>
                                    </div>
                                </div>
                                <div className='submit_btn'>
                                <button type="submit" className='rounded-pill btn solid_btn'>Submit <i class="fas fa-chevron-right"></i></button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className='col-md-5'>
                        <div className='left_side_img'>
                        <img src='images/statement-right.png' className='img_width' alt='form design'></img>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default InquiryForm;